import React from 'react';
import {connect} from 'react-redux';
import {selectors} from '../../Redux/index';

import PageContent from '../../Components/Helper/PageContent';

const Page = (props) => {
    switch (props.language) {
        case 'en':
            return (
                <PageContent>
                    <h1>db-markets Terms of Use</h1>
                    <a href={process.env.PUBLIC_URL + '/pdf/terms_of_use/terms_of_use.pdf'} target="_blank" style={{
                        color:' #005285',
                        textDecoration: 'underline',
                        fontWeight: '500'
                    }}>Download PDF-File</a>
                    <br />
                    <br />

                    <h2>1. No Offer</h2>
                    <p>Nothing contained on this db-markets website should be considered as an offer to purchase any of
                        the products as described on this db-markets website. Pricing levels and valuations published on
                        the db-markets website are indicative and they and other information displayed thereon are for
                        information purposes only.</p>

                    <h2>2. No accounting, tax, or legal advice</h2>
                    <p>It is important to note that Corporate Treasury Sales does not provide accounting, tax, or legal
                        advice. Notwithstanding any other expressed or implied agreement, agreement or understanding to
                        the contrary, we hereby authorize you to disclose to any and all persons the structure and the
                        tax aspects of potential transactions and all materials of any kind that are provided to you
                        related to such structure and tax aspects, without Deutsche Bank imposing any limitation of any
                        kind.</p>

                    <h2>3. Decisiveness of offering circular or prospectus</h2>
                    <p>An offering circular or prospectus referring to a specific product is available on the db-markets
                        website in certain cases. Users should carefully read the information contained therein before
                        making any investment decision.</p>

                    <h2>4. No investment advice</h2>
                    <p>Information made available on the db-markets website should not be considered as investment
                        advice or any form of recommendation to purchase products described thereon.</p>

                    <h2>5. Historical performance</h2>
                    <p>Past performance information contained on the db-markets website is not indicative of future
                        results.</p>

                    <h2>6. No warranties for contents</h2>
                    <p>Although best efforts have been used to ensure that the information set out on the db-markets
                        website is reliable, no warranty is made as to its accuracy, completeness and adequacy. Any
                        opinions expressed reflect the current view of Deutsche Bank AG, which may change without
                        notice.</p>

                    <h2>7. Use of the db-markets website</h2>
                    <h3>7.1. Changes of the db-markets website</h3>
                    <p>Deutsche Bank AG reserves the right to partly or completely change the db-markets website at any
                        time and to restrict, interrupt or terminate its service.</p>

                    <h3>7.2. Changes of General Terms and Conditions of Use</h3>
                    <p>Deutsche Bank AG reserves the right to modify or amend these terms and conditions at any
                        time.</p>

                    <h2>8. No Waiver</h2>
                    <p>No failure or delay on the part of Deutsche Bank AG in exercising any right shall operate as a
                        waiver of, or impair any such right. No single or partial exercise of any such right shall
                        preclude any other or further exercise thereof or the exercise of any other rights.</p>


                    <h2>9. Conflict of Interests</h2>
                    <p>Deutsche Bank AG and its directors, officers and employees may have or have had interests or
                        positions or traded or acted as market makers in securities or other values directly or
                        indirectly referred to on this website. Such entities or persons may have or have had a
                        relationship or may provide or have provided services to companies directly or indirectly
                        referred on this website.</p>

                    <h2>10. Copyright</h2>
                    <p>Content and design of the db-markets website are protected by copyright. Any copying of the
                        website or of its content requires the preliminary written consent of Deutsche Bank AG.</p>

                    <h2>11. Privacy Policy</h2>
                    <p>Deutsche Bank AG respects your privacy. Personal data, which are collected when visiting our
                        website, is processed according to requirements under German law and our Privacy Statement.</p>

                    <h2>12. Safety of Communication</h2>
                    <p>Communications over the internet and by e-mail cannot be guaranteed to be secure. There is a risk
                        that information contained within an e-mail communication and any attachment thereto, including
                        potentially confidential information, may be intercepted, lost, destroyed or delayed in
                        transmission. Although Deutsche Bank AG will use reasonable efforts to minimise such risk, it
                        does not warrant that any communication or e-mail or any attachments thereto, that is sent out,
                        will be free from viruses, worms or other harmful components.</p>

                    <h2>13. Hyperlinks</h2>
                    <p>Certain hypertext links on the db-markets website may lead the user to websites that are not
                        under the control or charge of Deutsche Bank AG. When a user clicks on such a link, he or she
                        leaves the db-markets website. Deutsche Bank AG is not responsible with respect to any material
                        contained on any other website.</p>

                    <h2>14. Governing Law; Jurisdiction</h2>
                    <h3>14.1. Governing Law</h3>
                    <p>These terms and conditions are exclusively governed by and shall be construed in accordance with
                        German law.</p>

                    <h3>14.2. Jurisdiction</h3>
                    <p>Each private user who is not a resident of one of the countries for which the Council Regulation
                        (EC) NO 44/2001 of 22 December 2000 on jurisdiction and the recognition and enforcement of
                        judgements in civil and commercial matters is applicable, or which have entered and ratified the
                        Convention on jurisdiction and enforcement of judgements in civil and commercial matters signed
                        at Lugano on 16 September 1988, and all commercial users are subject to the exclusive
                        jurisdiction of the competent court of Frankfurt am Main, Germany, in respect of any disputes
                        arising under these terms.</p>

                    <h2>15. Other agreements</h2>
                    <p>If at any time any provision (or part of any provision) of these terms and conditions is, or
                        becomes illegal, invalid or unenforceable in any respect under the law of any jurisdiction, that
                        shall not affect the legality, validity or enforceability in that or any other jurisdiction of
                        any other provision (or any other part of this provision) of these terms.</p>


                    <h2>16. Selling restrictions</h2>
                    <p>The products described on the db-markets website are not eligible for sale in all countries and
                        in any event may only be sold to qualified investors. The offering circulars contain information
                        as to the selling restrictions applicable to any particular product and the user should read
                        them carefully.</p>

                    <p>In particular, the following restrictions apply:</p>

                    <p>Residents of the United States of America</p>

                    <p>The information set out in the db-markets website is not directed to the United States. US
                        citizens (as defined in Regulation S under the US Securities Act 1933) and persons resident in
                        the US may not enter the db-markets website. Information from this db-markets website may not be
                        distributed or redistributed into the United States or into any jurisdiction where it is not
                        permitted. The securities have not been and will not be registered under the US Securities Act
                        of 1933 and trading in the securities has not been approved for purposes of the US Commodities
                        Exchange Act of 1936. The securities may not be offered or sold in the United States, to US
                        citizens or US residents.</p>

                    <p>The products described on the db-markets website are only offered or sold to persons in any other
                        jurisdiction, if applicable law permits this.</p>

                    <p>Published by Deutsche Bank AG.<br/> © Deutsche Bank AG, Frankfurt am Main.<br/> All rights
                        reserved.</p>
                </PageContent>
            );

        default:
            return (
                <PageContent>
                    <h1>db-markets Nutzungsbedingungen</h1>

                    <a href={process.env.PUBLIC_URL + '/pdf/terms_of_use/Nutzungsbedingungen.pdf'} target="_blank">Download PDF-File</a>
                    <br />
                    <br />

                    <h2>1. Kein Angebot</h2>
                    <p>Der Inhalt dieser db-markets Website ist nicht als Angebot zum Erwerb der auf der db-markets
                        Website beschriebenen Produkte zu verstehen. Die auf der db-markets Website angezeigten Kurse
                        und Bewertungen sind unverbindlich und dienen ebenso wie andere auf der db-markets Website
                        veröffentlichten Informationen lediglich zu Informationszwecken.</p>

                    <h2>2. Verkaufs- oder sonstige Prospekte als Entscheidungsgrundlage</h2>
                    <p>In einigen Fällen kann für ein bestimmtes Produkt ein Verkaufs- oder sonstiger Prospekt auf der
                        db-markets Website eingesehen werden. Die darin enthaltenen Informationen sollten vom Nutzer
                        sorgfältig gelesen werden, ehe eine Anlageentscheidung getroffen wird.</p>

                    <h2>3. Keine Anlageberatung</h2>
                    <p>Die auf der db-markets Website zur Verfügung gestellten Informationen stellen keine
                        Anlageberatung oder sonstige Empfehlung zum Erwerb der auf der db-markets Website beschriebenen
                        Produkte dar.</p>

                    <h2>4. Historische Wertentwicklung</h2>
                    <p>Die auf der db-markets Website enthaltenen Informationen zur Wertentwicklung in der Vergangenheit
                        bieten keine Gewähr für zukünftige Erträge.</p>

                    <h2>5. Keine Gewähr für Inhalte</h2>
                    <p>Obwohl die auf der db-markets Website enthaltenen Informationen Quellen entnommen wurden, die als
                        zuverlässig erachtet wurden, kann für deren Richtigkeit, Vollständigkeit und Angemessenheit
                        keine Gewähr übernommen werden. Alle Meinungsaussagen geben die aktuelle Einschätzung der
                        Deutsche Bank AG wieder, die ohne vorherige Ankündigung geändert werden kann.</p>

                    <h2>6. Nutzung der db-markets Website</h2>
                    <h3>6.1. Änderungen an der db-markets Website</h3>
                    <p>Die Deutsche Bank AG hat jederzeit das Recht, diese db-markets Website teilweise oder vollständig
                        zu verändern und deren Betrieb einzuschränken, zu unterbrechen oder einzustellen.</p>

                    <h3>6.2. Änderungen der Nutzungsbedingungen</h3>
                    <p>Die Deutsche Bank AG behält sich das Recht vor, diese Bedingungen jederzeit abzuändern und zu
                        ergänzen.</p>

                    <h2>7. Keine konkludente Verzichtserklärung</h2>
                    <p>Die Nichtausübung oder verspätete oder nur teilweise Ausübung von irgendwelchen Rechten seitens
                        der Deutsche Bank AG kann in keinem Fall als Verzicht auf dieses Recht gedeutet werden.</p>

                    <h2>8. Interessenkonflikte</h2>
                    <p>Die Deutsche Bank AG und ihre jeweiligen Vorstände, Direktoren und Angestellten können eigene
                        Interessen an Wertpapieren oder anderen Werten, auf die auf dieser Website direkt oder indirekt
                        hingewiesen wird, haben oder gehabt haben. Sie können außerdem Beziehungen zu Unternehmen
                        unterhalten oder unterhalten haben, auf die auf dieser Website direkt oder indirekt hingewiesen
                        wird.</p>

                    <h2>9. Urheberrechtsschutz</h2>
                    <p>Inhalt und Gestaltung der db-markets Website sind urheberrechtlich geschützt. Eine
                        Vervielfältigung der Seiten oder ihrer Inhalte bedarf der vorherigen schriftlichen Zustimmung
                        der Deutsche Bank AG.</p>

                    <h2>10. Datenschutz</h2>
                    <p>Die Deutsche Bank AG respektiert Ihre Privat- und Persönlichkeitssphäre. Wir verarbeiten
                        persönliche Daten, die beim Besuch unserer Webseiten erhoben werden, gemäß den deutschen
                        gesetzlichen Bestimmungen und unseren Datenschutzbestimmungen.</p>

                    <h2>11. Sicherheit der Datenkommunikation</h2>
                    <p>Für die Datensicherheit bei Übertragung via Internet und E-Mail wird keine Garantie übernommen.
                        Es besteht das Risiko, dass in einer E-Mail und Anhängen enthaltene Informationen,
                        einschließlich vertraulicher Informationen, während der Übertragung abgefangen oder zerstört
                        werden, verloren gehen oder verspätet eintreffen. Obgleich sich die Deutsche Bank AG in
                        angemessenen Maße bemühen wird, dieses Risiko zu verringern, kann nicht gewährleistet werden,
                        dass die von der Deutsche Bank AG versandten Informationen, E-Mails und deren Anhänge keine
                        Viren, Würmer oder sonstige schädigenden Elemente enthalten.</p>

                    <h2>12. Hyperlinks</h2>
                    <p>Bei einigen Hyperlinks der db-markets Website besteht die Möglichkeit, dass der Nutzer auf
                        Internetseiten geleitet wird, die nicht der Kontrolle oder Verantwortung der Deutsche Bank AG
                        unterstehen. Klickt der Nutzer einen solchen Link an, verlässt er die db-markets Website. Die
                        Deutsche Bank AG ist für den Inhalt der Webseiten, die aufgrund einer solchen Verbindung
                        erreicht werden, nicht verantwortlich.</p>

                    <h2>13. Anwendbares Recht; Gerichtsstand</h2>
                    <h3>13.1. Anwendbares Recht</h3>
                    <p>Diese Bedingungen unterliegen ausschließlich deutschem Recht.</p>

                    <h3>13.2. Gerichtsstand</h3>
                    <p>Jeder private Nutzer, der nicht in einem der Staaten ansässig ist, für welche die Verordnung (EG)
                        Nr. 44/2001 des Rates vom 22. Dezember 2000 über die gerichtliche Zuständigkeit und die
                        Anerkennung und Vollstreckung von Entscheidungen in Zivil- und Handelssachen Anwendung findet
                        oder die dem am 16.September 1988 in Lugano unterzeichneten Übereinkommen über die gerichtliche
                        Zuständigkeit und die Vollstreckung von Entscheidungen in Zivil- und Handelssachen angehören und
                        dieses ratifiziert haben, und alle gewerblichen Nutzer unterstehen in Bezug auf
                        Rechtsstreitigkeiten im Zusammenhang mit diesen Bedingungen der ausschließlichen Gerichtsbarkeit
                        des zuständigen Gerichts in Frankfurt am Main, Deutschland.</p>

                    <h2>14. Sonstige Vereinbarungen</h2>
                    <p>Sollte zu irgendeiner Zeit eine Bestimmung (oder ein Teil einer Bestimmung) dieser Bedingungen
                        nach den Rechtsnormen einer Rechtsordnung rechtswidrig, unwirksam oder nicht durchsetzbar sein
                        oder werden, so bleiben die Rechtmäßigkeit, Wirksamkeit oder Durchsetzbarkeit der übrigen
                        Bestimmungen (oder der übrigen Teile dieser Bestimmung) dieser Bedingungen in dieser oder einer
                        anderen Rechtsordnung davon unberührt.</p>


                    <h2>15. Verkaufsbeschränkungen</h2>
                    <p>Die auf der db-markets Website beschriebenen Produkte dürfen nicht in allen Ländern zum Verkauf
                        angeboten werden und sind in jedem Fall dem Personenkreis vorbehalten, der zum Kauf der Produkte
                        berechtigt ist. Die für bestimmte Produkte geltenden Verkaufsbeschränkungen werden in den
                        jeweiligen Prospekten dargelegt und sollten vom Nutzer sorgfältig gelesen werden.</p>

                    <p>Insbesondere gelten folgenden Beschränkungen:</p>

                    <p>In den USA ansässige Rechtssubjekte</p>

                    <p>Die auf der db-markets Website enthaltenen Informationen sind nicht für die USA bestimmt.
                        US-Bürgern (gemäß Definition in Regulation S des US-Securities Act von 1933) und in den USA
                        ansässigen Rechtssubjekten ist der Zugriff auf die db-markets Website untersagt. Auf dieser
                        db-markets Website bereitgestellte Informationen dürfen nicht in den USA oder anderen Ländern
                        verbreitet oder weitergegeben werden, deren Rechtsvorschriften dadurch verletzt würden. Die hier
                        aufgeführten Wertpapiere sind und werden nicht gemäß dem US-Securities Act (Wertpapiergesetz)
                        von 1933 registriert, und für den Handel mit diesen Wertpapieren wurde keine Genehmigung gemäß
                        dem US-Commodities Exchange Act (Warenbörsengesetz) von 1936 eingeholt. Die Wertpapiere dürfen
                        nicht in den USA, an US-Bürger oder in den USA ansässige Rechtssubjekte verkauft oder diesen
                        angeboten werden.</p>

                    <p>Die auf der db-markets Website beschriebenen Produkte werden anderen Rechtsordnungen
                        unterstehenden Rechtssubjekten nur angeboten oder verkauft, wenn dies nach den jeweils
                        anwendbaren Rechtsvorschriften zulässig ist.</p>

                    <p>Veröffentlicht durch Deutsche Bank AG.<br/> © Deutsche Bank AG, Frankfurt am Main.<br/> Alle
                        Rechte vorbehalten.</p>
                </PageContent>
            );
    }
};

const mapStateToProps = (state) => {
    return {
        language: selectors.UI.Locale.getLocale(state)
    };
};

export default connect(mapStateToProps)(Page);
